import { jwtDecode } from 'jwt-decode';

export const getJwtParam = (jwt: string | null, param: string, defaultValue: string): string => {
  if (jwt === null || jwt === '') {
    return defaultValue;
  }
  const payload = jwtDecode(jwt);
  if (payload && payload[param]) {
    return payload[param];
  }
  return defaultValue;
};
